export default {
  // Common elements
  common: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    search: "Search",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    submit: "Submit",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    all: "All",
    rating: "Rating",
    services: "Services",
    hajj: "Hajj",
    umra: "Umra",
  },

  // Navigation
  navigation: {
    home: "Home",
    about: "About",
    news: "News",
    article: "Articles",
    qa: "Q&A",
    tours: "Tours",
    other: "More",
    contacts: "Contacts",
    profile: "Profile",
    login: "Login",
    register: "Register",
    logout: "Logout",
  },

  // Headers
  headers: {
    logoTitle: "Kazakhstan Hajjis",
    logoSubtitle: "Hajj.kz",
  },

  // Menu
  menu: {
    home: "Home",
    about: "About",
    news: "News",
    contacts: "Contacts",
    profile: "Profile",
    liveStreaming: "Live Streaming",
    sendPrayer: "Send Prayer",
  },

  // Languages
  languages: {
    kk: "Қаз",
    ru: "Рус",
    en: "Eng",
  },

  // Regions
  regions: {
    astana: "Astana",
    almaty: "Almaty",
    shymkent: "Shymkent",
    aktobe: "Aktobe",
    karaganda: "Karaganda",
    taraz: "Taraz",
    pavlodar: "Pavlodar",
    oskemen: "Oskemen",
    semey: "Semey",
    atyrau: "Atyrau",
    uralsk: "Uralsk",
    kyzylorda: "Kyzylorda",
    aktau: "Aktau",
    petropavl: "Petropavl",
    kokshetau: "Kokshetau",
    taldykorgan: "Taldykorgan",
  },

  // Prayer times
  prayerTimes: {
    fajr: "Fajr",
    sunrise: "Sunrise",
    dhuhr: "Dhuhr",
    asr: "Asr",
    maghrib: "Maghrib",
    isha: "Isha",
  },

  // Forms
  forms: {
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone",
    city: "City",
    region: "Region",
    address: "Address",
    birthDate: "Birth Date",
    passportNumber: "Passport Number",
    required: "Required field",
    invalidEmail: "Invalid email",
    passwordMismatch: "Passwords do not match",
    fullName: "Full Name",
    phonePlaceholder: "+7 (___) ___-__-__",
    phoneError: "Enter correct phone number",
  },

  // Messages
  messages: {
    success: "Successfully completed",
    error: "An error occurred",
    warning: "Warning",
    info: "Information",
    saved: "Saved",
    deleted: "Deleted",
    updated: "Updated",
    languageChanged: "Language changed",
  },

  // Authentication
  auth: {
    welcome: "Welcome!",
    connectToSystem: "Connect to system",
    loginTitle: "Login",
    registerTitle: "Register",
    forgotPassword: "Forgot password?",
    rememberMe: "Remember me",
    loginButton: "Login",
    registerButton: "Register",
    resetPassword: "Reset password",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    loginSuccess: "Login successful",
    registerSuccess: "Registration successful",
    logoutSuccess: "Logout successful",
    registerSuccessTitle: "Successfully registered!",
    registerSuccessDescription:
      "To log in to the system, enter your login and password.",
    loginButtonText: "Login",
  },

  // Profile
  profile: {
    personalInfo: "Personal Information",
    orders: "Orders",
    settings: "Settings",
    changePassword: "Change Password",
    editProfile: "Edit Profile",
    saveChanges: "Save Changes",
    personalCabinet: "Personal Cabinet",
    editPersonalInfo: "Edit Personal Information",
    fullName: "Full Name",
    fullNamePlaceholder: "Enter your full name",
    emailPlaceholder: "Enter E-mail",
    removeEmail: "Remove E-mail",
    save: "Save",
    saving: "Saving...",
    noOrders: "You have no applications",
    orderDate: "Application date",
    pilgrimName: "Pilgrim name",
    status: "Status",
    statusPublished: "Published",
    statusModeration: "Under moderation",
    statusAccepted:
      "Your application has been accepted! You are registered in the hajj database.",
    statusPending:
      "Under consideration. After the application is accepted, your profile will be published in the database.",
    logout: "Logout from system",
  },

  // Hajj
  hajj: {
    title: "Hajj",
    mission: "Mission",
    register: "Register",
    search: "Search",
    holyPlaces: "Holy Places",
    tourOperators: "Tour Operators",
    news: "News",
    videos: "Videos",
    photos: "Photos",
    books: "Books",
    hajjis: "Hajjis",
    hajjisList: "Hajjis List",
    hajjUmra: "Hajj and Umra",
    tourCompanies: "Tour Companies",
    hajjMission: "Kazakhstan Hajj Mission",
    hajjRegistration: "Kazakhstan Hajjis Registration Database",
    registeredHajjis: "Registered Hajjis",
    hajjYear: "Year of Hajj",
    selectRegion: "Select Region:",
    searchHajjis: "Search Hajjis",
    searchSubtitle: "Enter name and select region to search",
    fullName: "Full Name",
    selectYear: "Year of Hajj",
    hajjDate: "Year of Hajj trip",
    hajjUntil: "Until Hajj",
    hajjDateText: "Hajj {day} {month} {year}",
    hajjYearText: "Year of Hajj trip",
    age: "Age",
    region: "Region",
    biography: "Biography",
    impressions: "Impressions from Hajj",
    advice: "Advice for Hajjis",
    hajjAccepted: "May your Hajj be accepted!",
    amin: "Amin!",
    dua: "Make Dua for Me",
    duaDescription:
      "You can request dua for yourself or your loved ones. May Allah accept every dua!",
    sendDua: "Send Dua",
    searchByName: "Search by name",
    new: "New",
    old: "Old",
    sampleDuaText:
      "Allahumma inni as'aluka min khayri ma sa'alaka minhu nabiyyuka Muhammadun sallallahu alayhi wa sallam, wa a'udhu bika min sharri ma ista'aza minhu nabiyyuka Muhammadun sallallahu alayhi wa sallam.",
    authorName: "Akhmetov Azamat",
    authorDetails: "Year of Hajj: 2024",
    hajjiMadeDua: "hajji made dua",
    noDua: "No dua",
    duaForm: {
      title: "Send Dua",
      subtitle:
        "You can request dua for yourself or your loved ones. May Allah accept every dua!",
      region: "Region",
      duaType: "Dua Type",
      duaText: "Dua Text (required)",
      duaTextPlaceholder:
        "Write your dua request... (for example: «I ask for dua for the health of my sister Saltanat...»)",
      submitButton: "Send Dua",
      submitting: "Sending...",
      fillAllFields: "Fill in all fields",
      successTitle: "Your dua request has been successfully accepted!",
      successDescription:
        "After moderation, it will be published on the site. May Allah accept your intention!",
      closeButton: "Close",
      sendAnotherButton: "Send Another Dua",
    },
    duaActions: {
      noDuaYet:
        "No hajji has made dua for this intention yet. Be the first to sincerely make dua and contribute to a good cause!",
      makeDua: "Make Dua",
      duaLiked: "Your dua has been successfully sent!",
      youMadeDua: "You have already made dua",
    },
    months: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December",
    },
  },

  // Media
  media: {
    title: "Media",
    articles: "Articles",
    qa: "Q&A",
    videoSection: "Videos",
    photoGallery: "Photo Gallery",
    library: "Library",
    goToQa: "Go to Q&A",
    goToNews: "Go to News",
    moreDetails: "More Details",
    videoContent: "Video Content",
    videos: "Videos",
    photos: "Photo Gallery",
    books: "Library",
    author: "Author",
    publisher: "Publisher",
    pages: "Number of pages",
    year: "Year of publication",
    shortDescription: "Short description",
    read: "Read",
    noAdditionalInfo: "No additional information",
    seeAlso: "See also",
    share: "Share",
    linkCopied: "Link copied",
    copyFailed: "Failed to copy link",
    category: "Category",
    source: "Source",
    views: "Views",
    date: "Date",
  },

  // Live streaming
  liveStreaming: {
    title: "Live Streaming",
    liveStream: "live stream",
    mekke: "Mecca",
    medina: "Medina",
  },

  // Footer
  footer: {
    contact: "Contact",
    address: "Address",
    phone: "Phone",
    email: "Email",
    social: "Social Networks",
    copyright: "Copyright",
    allRightsReserved: "All rights reserved",
    addressValue: "Astana, Karasaz St., 3",
    phoneValue: "+ 7 (7172) 999 387",
    registered: "Registered",
    hajji: "hajji",
    applyButton: "Apply",
    onlineStreaming: "Online Streaming",
  },

  // Statistics
  stats: {
    registered: "Registered",
    hajji: "hajji",
    count: "401",
  },

  // Holy places
  holyPlaces: {
    title: "Holy Places",
    mecca: "Mecca",
    medina: "Medina",
    meccaDescription: "The holiest city of Islam, the location of the Kaaba.",
    medinaDescription:
      "The place where Prophet Muhammad (s.a.w.) migrated and was buried.",
    all: "All",
    kaaba: "Kaaba (Al-Masjid Al-Haram)",
    kaabaDescription:
      "The Kaaba is the holiest place in Islam. According to Muslim belief, it was built by Ibrahim (a.s.) and his son Ismail (a.s.) by Allah's command. The Kaaba is the qibla of Muslims, that is, the direction they face during prayer. It is a symbol of the unity of Islam and devotion to Allah.",
    location: "Location: Mecca",
    map: "Map",
  },

  // Tour operators
  tourOperators: {
    title: "Tour Operators",
    rating: "Rating",
    services: "Services",
    hajj: "Hajj",
    umra: "Umra",
    serviceType: "Service type",
    features: "Features",
    location: "Location",
    photoGallery: "Photo Gallery",
    links: "Links",
    contactNumber: "Contact number",
    logoAlt: "Tour operator logo",
    evaluation: "Rating and leaving a review",
    evaluationText:
      "To rate the tour operator's services, log in to the site or register",
    reviews: "Reviews",
    reply: "Reply",
    companyName: "Atlas Tourism",
    replyText:
      "Azamat, thank you for your review! We are glad to see you again.",
    reviewText1:
      "I was on Hajj. Well-organized tour. Guides and group leaders were very helpful. Thank you everyone!",
    reviewText2: "Very good tour. Next year I will go with this company again.",
    userName1: "Gulnara Aliyeva",
    userName2: "Azamat Serikov",
    viewTours: "View Tours",
  },

  // Articles
  articles: {
    back: "Back",
    share: "Share",

    seeAlso: "See also",
    category: "Category",
    source: "Source",
  },

  // FAQ
  faq: {
    title: "Q&A",
    goToQa: "Go to Q&A",
    loading: "Loading...",
    error: "An error occurred while loading data. Try again later.",
  },

  // Mission
  mission: {
    organizeHajj: "Organization and control of Hajj",
    getQuota: "Obtaining Hajj quota for Kazakhstan",
    approveOperators: "Approval of tour operators organizing Hajj",
    monitorRegistration: "Monitoring the Hajj registration system",
    religiousAdvice: "Religious consultations for Hajjis",
    qualityControl: "Quality control of tour operator services",
    security: "Ensuring security of Hajjis",
    evaluation: "Evaluation of Hajj quality and reporting",
  },

  // Partners
  partners: {
    title: "Our Partners",
  },

  // News
  news: {
    title: "News",
    goToNews: "Go to News",
    moreDetails: "More Details",
    latest: "Latest news",
  },

  // Region selector
  regionSelector: {
    title: "Select Region",
    search: "Search",
    back: "Back",
  },

  // Pagination
  pagination: {
    back: "Back",
    next: "Next",
  },

  // Mobile apps
  mobileApps: {
    title: "Qaji Guide",
    subtitle: "Free digital assistant tool for Hajj and Umra performers",
  },

  // Time (for CountDown)
  time: {
    days: "days",
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds",
  },

  // Additional elements
  additional: {
    addressLabel: "Address:",
    phoneLabel: "Phone:",
    copyrightText: "2025 © Kazakhstan Hajjis. All rights reserved",
  },

  // Pilgrim form
  pilgrimForm: {
    title: "Apply",
    description:
      "Have you or your relative been on Hajj? Register in the Kazakhstan Hajjis database",
    step1Title: "Personal Information",
    step2Title: "Biography",
    step3Title: "Impressions from Hajj",
    step3AdviceTitle: "Advice for Hajjis",
    fields: {
      lastName: "Last Name",
      firstName: "First Name",
      fatherName: "Father's Name",
      age: "Age",
      ageHint: "What age did you go on Hajj?",
      region: "Region, settlement",
      regionHint: "Example: Almaty region, Talgar district",
      hajjYear: "Year of Hajj trip",
      iin: "IIN",
      photo: "Upload Photo",
      biography: "Biography",
      biographyPlaceholder: "Write your biography",
      biographyHint:
        "For example: place of birth, profession, family, religious activities",
      impressions: "Impressions from Hajj",
      impressionsPlaceholder: "Write your impressions from Hajj",
      impressionsHint:
        "For example: The moment I first saw the Kaaba during Hajj became the most unforgettable moment of my life",
      advice: "Advice for Hajjis",
      advicePlaceholder: "Write your advice for Hajjis",
      adviceHint:
        "Example: advice, preparation, dua, patience, spiritual advice",
    },
    photoUpload: {
      title: "Upload Photo",
      description: "Upload your official photo or photo in Ihram",
      button: "Upload",
      hint: "* For example: passport format or photo during Hajj",
    },
    validation: {
      lastName: "Enter your last name",
      firstName: "Enter your first name",
      age: "Enter your age",
      region: "Select region, settlement",
      hajjYear: "Enter the year of Hajj trip",
      iin: "Enter your IIN",
      photo: "Upload your photo",
    },
    buttons: {
      next: "Next",
      submit: "Submit Application",
    },
    messages: {
      success: "Your application has been sent",
      error: "Your application was not sent",
    },
  },

  // Tours
  tours: {
    title: "Tours",
    filter: "Filter",
    reset: "Reset",
    priceFrom: "From",
    priceTo: "To",
    duration: "Duration",
    packageType: "Select package type",
    tourType: "Tour type",
    allCities: "All cities",
    orderButton: "Book now",
    moreDetails: "More details",
    remainingSeats: "Remaining seats",
    noToursFound: "No tours found matching your filters",
    clearFilters: "Clear filters",
    loadingError: "Error loading tours",
    retry: "Retry",
    company: "Company",
    tourOperators: "Tour Operators",
    departureDate: "Departure date",
    returnDate: "Return date",
    directFlight: "direct flight",
    oneTransfer: "1 transfer",
    transfers: "{count} transfers",
    medinaIn: "In Medina",
    meccaIn: "In Mecca",
    medinaCity: "Medina",
    meccaCity: "Mecca",
    nights: "nights",
    dayPackage: "day package",
    econom: "Economy",
    standart: "Standard",
    comfort: "Comfort",
    lux: "Luxury",
    all: "All",
    umra: "Umra",
    hajj: "Hajj",
    days7: "7 days",
    days10: "10 days",
    days14: "14 days",
    days21: "21 days",
    days30: "30 days",
    back: "Back",
    aboutPackage: "About package",
    flightTime: "Flight time",
    hajjDays: "Hajj days",
    packageIncludes: "What's included",
    writeManager: "Write to manager",
    route: "Route",
    outbound: "Outbound",
    returnTrip: "Return",
    hotels: "Hotels",
    hotelsDescription:
      "Within this program, you will be accommodated in the hotels listed below in Mecca and Medina. The hotel level and conditions correspond to the package class (Economy / Comfort / Luxury).",
    medinaHotel: "Hotel in Medina",
    meccaHotel: "Hotel in Mecca",
    distanceToNabawi: "Distance to Masjid an-Nabawi:",
    distanceToHaram: "Distance to al-Haram:",
    onFoot: "on foot",
    accommodation: "Accommodation",
    meals: "Meals",
    nightsCount: "Number of nights",
    viewGallery: "View gallery",
    detailLoadError: "Error loading tour details",
    booking: {
      fullName: "Your name, surname",
      phone: "Phone number",
      email: "E-mail",
      consent:
        "I consent to the processing of my personal data. The data is used for processing the application, contacting and arranging the tour. Privacy policy —",
      consentLink: "link.",
      submitting: "Submitting...",
      submit: "Book now",
      successTitle: "Your application has been accepted!",
      successText:
        "We will contact you shortly. The manager will clarify all the details of the package.",
      successButton: "OK",
    },
  },

  // About
  about: {
    title: "This is an about page",
  },
};
